module.exports = __webpack_public_path__ + "img/pupil_black_blurred.8e20a1fc.png";